import { render, staticRenderFns } from "./verificaUbicacion.vue?vue&type=template&id=0bd1fb24&scoped=true"
import script from "./verificaUbicacion.vue?vue&type=script&lang=js"
export * from "./verificaUbicacion.vue?vue&type=script&lang=js"
import style0 from "./verificaUbicacion.vue?vue&type=style&index=0&id=0bd1fb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1fb24",
  null
  
)

export default component.exports